import { SxProps } from '@mui/material';
import { BaseTheme } from './base-theme';

export const mergeSx = (...sxProps: SxProps<BaseTheme>[]): SxProps<BaseTheme> => {
  return sxProps.reduce((prev, currentValue) => {
    return [...(Array.isArray(prev) ? prev : [prev]), ...(Array.isArray(currentValue) ? currentValue : [currentValue])];
  }, [] as SxProps<BaseTheme>);
};
